/* QUILLMORE (repris de 9HEAT) — barre d'achat fixe v2 (mobile + ordinateur).
   Crée une barre unique, masque les anciennes barres des modèles, ne touche à aucun gestionnaire du formulaire.
   En cas de problème (formulaire ou bouton introuvable), rien n'est modifié : l'ancienne barre reste en place. */
(function () {
  'use strict';
  if (window.__nhProductSticky) return;
  var context = document.getElementById('nh-product-sticky-context');
  if (!context) return;
  var product;
  try { product = JSON.parse(context.textContent); } catch (_) { return; }
  var form = document.querySelector('[data-product-form], [data-ncr-form]');
  var primary = form && form.querySelector('[data-add-to-cart], [data-ncr-atc]');
  if (!form || !primary) return;
  window.__nhProductSticky = true;

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var french = String(product.locale || 'fr').split('-')[0] === 'fr';
  var lang = String(product.locale || 'fr').split('-')[0];
  var DICT = {
    fr: {size: 'Choisir ma taille', options: 'Choisir mes options', pack: 'Choisir mon pack', add: 'Ajouter au panier', gift: 'Batterie + livraison offertes', ship: 'Livraison offerte · 90 jours', chipGift: 'Batterie offerte', chipShip: 'Livraison offerte', chipDays: '90 jours', region: 'Achat rapide'},
    en: {size: 'Choose my size', options: 'Choose my options', pack: 'Choose my bundle', add: 'Add to cart', gift: 'Free battery + shipping', ship: 'Free shipping · 90 days', chipGift: 'Free battery', chipShip: 'Free shipping', chipDays: '90 days', region: 'Quick buy'},
    nb: {size: 'Velg størrelse', options: 'Velg alternativer', pack: 'Velg pakke', add: 'Legg i handlekurven', gift: 'Gratis batteri + frakt', ship: 'Gratis frakt · 90 dager', chipGift: 'Gratis batteri', chipShip: 'Gratis frakt', chipDays: '90 dager', region: 'Hurtigkjøp'},
    es: {size: 'Elegir mi talla', options: 'Elegir mis opciones', pack: 'Elegir mi pack', add: 'Añadir al carrito', gift: 'Batería + envío gratis', ship: 'Envío gratis · 90 días', chipGift: 'Batería de regalo', chipShip: 'Envío gratis', chipDays: '90 días', region: 'Compra rápida'},
    it: {size: 'Scegli la taglia', options: 'Scegli le opzioni', pack: 'Scegli il pack', add: 'Aggiungi al carrello', gift: 'Batteria + spedizione in omaggio', ship: 'Spedizione gratuita · 90 giorni', chipGift: 'Batteria in omaggio', chipShip: 'Spedizione gratuita', chipDays: '90 giorni', region: 'Acquisto rapido'},
    nl: {size: 'Kies mijn maat', options: 'Kies mijn opties', pack: 'Kies mijn pakket', add: 'In winkelwagen', gift: 'Gratis batterij + verzending', ship: 'Gratis verzending · 90 dagen', chipGift: 'Gratis batterij', chipShip: 'Gratis verzending', chipDays: '90 dagen', region: 'Snel kopen'}
  };
  var T = DICT[lang] || DICT.en;

  function text(node) { return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function money(value) { var n = parseFloat(String(value).replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.')); return isNaN(n) ? null : n; }

  var segments = String(product.title || '').split(/\s[-–—]\s/);
  var shortName = segments.reduce(function (a, b) { return b.trim().length < a.trim().length ? b : a; }).replace(/^\s*(9HEAT|QUILLMORE)\s+/i, '').trim();

  var giftSource = [product.badge || '', text(document.querySelector('.nh-gift-offer')), (document.querySelector('[data-product-badge]') || {getAttribute: function () { return ''; }}).getAttribute('data-product-badge') || ''].join(' ');
  var hasGift = (/batter/i.test(giftSource) && /offert|free/i.test(giftSource)) || !!document.querySelector('[data-nh-bundle-selector][data-battery-variant]');

  var trust = text(document.querySelector('.nh-cat__product-trust-row, .nh-pdp__trust-row, [data-nh-rating]'));
  var rateMatch = trust.match(/\b([1-5][,.]\d)\b/);
  var rate = rateMatch ? rateMatch[1].replace('.', ',') : '';

  var bar = document.createElement('div');
  bar.id = 'nh-sticky-v2';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', T.region);
  bar.innerHTML =
    '<div class="nhs2__in">' +
      (product.img ? '<img class="nhs2__img" alt="" width="46" height="46" loading="lazy" decoding="async">' : '') +
      '<div class="nhs2__info">' +
        '<div class="nhs2__top"><span class="nhs2__name"></span>' + (rate ? '<span class="nhs2__rate"><span class="nhs2__star" aria-hidden="true">★</span><span class="nhs2__stars" aria-hidden="true">★★★★★</span> ' + rate + '</span>' : '') + '</div>' +
        '<div class="nhs2__price"><span class="nhs2__now"></span><s class="nhs2__was"></s><span class="nhs2__off"></span></div>' +
      '</div>' +
      '<div class="nhs2__chips">' + (hasGift ? '<span class="nhs2__chip">' + T.chipGift + '</span>' : '') + '<span class="nhs2__chip">' + T.chipShip + '</span><span class="nhs2__chip">' + T.chipDays + '</span></div>' +
      '<button type="button" class="nhs2__cta"><span class="nhs2__label"></span><small class="nhs2__sub">' + (hasGift ? T.gift : T.ship) + '</small></button>' +
    '</div>';
  var img = bar.querySelector('.nhs2__img');
  if (img) img.src = product.img;
  bar.querySelector('.nhs2__name').textContent = shortName;
  bar.querySelector('.nhs2__name').title = product.title || '';
  var nowEl = bar.querySelector('.nhs2__now');
  var wasEl = bar.querySelector('.nhs2__was');
  var offEl = bar.querySelector('.nhs2__off');
  var labelEl = bar.querySelector('.nhs2__label');
  var cta = bar.querySelector('.nhs2__cta');
  document.body.appendChild(bar);
  root.classList.add('nh-sticky-v2-on');

  function sizeChoice() {
    var pills = form.querySelectorAll('.nh-size-pill, [data-nh-size-pill]');
    if (pills.length > 1) return true;
    return Array.prototype.some.call(form.querySelectorAll('select:not([name="id"])'), function (el) {
      var label = el.getAttribute('aria-label') || (el.closest('label') ? el.closest('label').textContent : '');
      return el.options.length > 1 && /taille|size|pointure/i.test(label);
    });
  }
  function otherChoice() {
    return Array.prototype.some.call(form.querySelectorAll('select:not([name="id"])'), function (el) {
      return el.options.length > 1 && el.getClientRects().length;
    });
  }
  function action() {
    if (product.variantCount > 1 && sizeChoice()) return {text: T.size, choose: true};
    var bundle = form.querySelector('[data-nh-bundle-selector]');
    if (bundle && bundle.getClientRects().length) return {text: T.pack, choose: true};
    if (product.variantCount > 1 && otherChoice()) return {text: T.options, choose: true};
    return {text: T.add, choose: false};
  }
  function headerBottom() {
    var header = document.querySelector('.nh-header, .site-header, [data-header]');
    if (!header) return 0;
    var r = header.getBoundingClientRect();
    var pos = getComputedStyle(header).position;
    return (pos === 'fixed' || pos === 'sticky') && r.top <= 0 && r.bottom > 0 ? r.bottom : 0;
  }
  function target() {
    return form.querySelector('.nh-size-option-head, .nh-product-option--size, .nh-cat__options, [data-option-index]') || form;
  }

  var queued = false;
  function sync() {
    queued = false;
    var priceNode = primary.querySelector('[data-atc-price]') || document.querySelector('[data-ncr-price], .nh-cat__buybox .nh-cat__current, .nh-pdp__buybox .nh-pdp__current');
    var compareNode = primary.querySelector('[data-atc-compare]:not([hidden])') || document.querySelector('.nh-cat__buybox .nh-cat__compare, .nh-pdp__buybox .nh-pdp__compare, [data-b4-compare]');
    var now = text(priceNode);
    var was = compareNode && !compareNode.hidden ? text(compareNode) : '';
    var n = money(now), w = money(was);
    if (!(w && n && w > n)) was = '';
    if (nowEl.textContent !== now) nowEl.textContent = now;
    if (wasEl.textContent !== was) wasEl.textContent = was;
    var off = was ? '-' + Math.round((1 - n / w) * 100) + ' %' : '';
    if (offEl.textContent !== off) offEl.textContent = off;
    bar.classList.toggle('nhs2--no-was', !was);
    var next = action();
    if (labelEl.textContent !== next.text) labelEl.textContent = next.text;
    cta.setAttribute('aria-label', next.text);
    cta.disabled = !next.choose && (primary.disabled || primary.getAttribute('aria-disabled') === 'true');
    var vv = window.visualViewport;
    var top = vv ? vv.offsetTop : 0;
    var bottom = top + (vv ? vv.height : window.innerHeight);
    var r = primary.getBoundingClientRect();
    var onScreen = r.height > 0 && r.bottom > Math.max(top, headerBottom()) && r.top < bottom - 8;
    var visible = !onScreen && r.height > 0;
    if (visible !== bar.hasAttribute('data-visible')) {
      bar.toggleAttribute('data-visible', visible);
      document.dispatchEvent(new CustomEvent('nh:sticky-change'));
    }
  }
  function schedule() { if (!queued) { queued = true; window.requestAnimationFrame(sync); } }

  cta.addEventListener('click', function () {
    if (action().choose) {
      var y = target().getBoundingClientRect().top + window.scrollY - headerBottom() - 16;
      window.scrollTo({top: Math.max(0, y), behavior: reduced.matches ? 'auto' : 'smooth'});
    } else if (!primary.disabled && primary.getAttribute('aria-disabled') !== 'true') {
      primary.click();
    }
  });

  new MutationObserver(schedule).observe(primary, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden']});
  if (window.IntersectionObserver) new IntersectionObserver(schedule, {threshold: [0, 1]}).observe(primary);
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(form);
  form.addEventListener('change', schedule);
  form.addEventListener('click', schedule);
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('nh:bundle-selection-changed', schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, {passive: true});
    window.visualViewport.addEventListener('scroll', schedule, {passive: true});
  }
  sync();
})();
